import React from "react";

export function GrowChatGmeet() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M10 3.5L0 13.5L5 16.5951L10 13.5L12.8235 8.5L10 3.5Z" fill="#FF2820" />
      <path d="M10 13.5002H0V26.5002L5 29.2459L10 26.5002V13.5002Z" fill="#0084FF" />
      <path d="M0 26.5V33.1666C0 35 1.5 36.5 3.33336 36.5H10L12.8235 31.192L10 26.5H0Z" fill="#0066DD" />
      <path d="M37.9343 7.05059L31.7495 11.9499V12.0001L29.7324 19.7009L31.7495 27.4941L37.9068 32.4497C38.7329 33.1429 39.9995 32.5606 39.9995 31.4792V8.02106C39.9995 6.93966 38.7604 6.35739 37.9343 7.05059Z" fill="#00AD3C" />
      <path d="M31.75 11.95V6.79532C31.75 4.98306 30.2819 3.50024 28.4875 3.50024H21.9625H10V13.5002H22.25V20.0002L28.8316 19.267L31.75 11.95Z" fill="#FFBA00" />
      <path d="M22.25 26.5001H10V36.5001H21.9625H28.4875C30.2819 36.5001 31.75 35.0195 31.75 33.2098V27.5001L28.4849 20.7922L22.25 20.0001V26.5001Z" fill="#00AD3C" />
      <path d="M22.25 20.0001L31.75 27.5001V11.9498L22.25 20.0001Z" fill="#00831E" />
    </svg>
  );
}
